import { get, post, patch, del } from './apiClient';

// Types
export interface ReferenceWithAnswers {
  id: string;
  candidate_id: string;
  full_name: string;
  company: string;
  relationship_type: string;
  department: string;
  email: string;
  phone?: string;
  linkedin?: string;
  years_worked: number;
  seniority: string;
  filled_form_at?: string;
  sent_email_at?: string;
  answers: ReferenceAnswer[];
}

export interface ReferenceAnswer {
  id: string;
  referenceId: string;
  questionId: string;
  textAnswer: string;
  dateAnswer: string;
}

export interface ReferenceCreateDTO {
  full_name: string;
  company: string;
  relationship_type: string;
  department: string;
  email: string;
  phone?: string;
  linkedin?: string;
  years_worked: number;
  seniority: string;
  candidate_id: string;
}

export interface ReferenceUpdateDTO {
  full_name?: string;
  company?: string;
  relationship_type?: string;
  department?: string;
  email?: string;
  phone?: string;
  linkedin?: string;
  years_worked?: number;
  seniority?: string;
}

// API functions
export const referencesApi = {
  // Get all references, optionally filtered by candidate ID
  getAll: async (candidateId?: string): Promise<ReferenceWithAnswers[]> => {
    const endpoint = candidateId 
      ? `/references?candidate_id=${encodeURIComponent(candidateId)}`
      : '/references';
    return get<ReferenceWithAnswers[]>(endpoint);
  },

  // Get a single reference by ID
  getById: async (referenceId: string): Promise<ReferenceWithAnswers> => {
    return get<ReferenceWithAnswers>(`/references/${referenceId}`);
  },

  // Create a new reference
  create: async (referenceData: ReferenceCreateDTO): Promise<ReferenceWithAnswers> => {
    console.log('API creating reference with data:', JSON.stringify(referenceData));
    
    // The endpoint requires the candidate_id in the path
    return post<ReferenceWithAnswers>(`/references/${referenceData.candidate_id}`, referenceData);
  },

  // Update a reference
  update: async (referenceId: string, referenceData: ReferenceUpdateDTO): Promise<ReferenceWithAnswers> => {
    return patch<ReferenceWithAnswers>(`/references/${referenceId}`, referenceData);
  },

  // Delete a reference
  delete: async (referenceId: string): Promise<void> => {
    return del<void>(`/references/${referenceId}`);
  },

  // Resend email to reference
  resendEmail: async (referenceId: string): Promise<any> => {
    return post<any>(`/references/${referenceId}/send-email`, '');
  },
  
  // Get reference form URL
  getFormUrl: async (referenceId: string): Promise<{ url: string }> => {
    return get<{ url: string }>(`/references/${referenceId}/form-url`);
  }
};